module.exports = __webpack_public_path__ + "img/AT0000002858031.daf2796c.png";